import { debounce } from 'lodash-es'

// directive will be used on multiple fields, but only want to bind to document once. Using the following two flags to acheive this.
let bound = false
let unbound = false

const debouncedEscHandler = debounce(e => {
  if (
    e.key === `Escape` &&
    [`INPUT`, `TEXTAREA`].includes(document.activeElement.tagName)
  ) {
    document.activeElement.blur()
  }
})

export default {
  bind() {
    if ((bound = !bound))
      document.addEventListener(`keyup`, debouncedEscHandler)
  },
  unbind() {
    if ((unbound = !unbound))
      document.removeEventListener(`keyup`, debouncedEscHandler)
  },
}
